import { render, staticRenderFns } from "./TrainingVideoEdit.vue?vue&type=template&id=7c0d2dc9&scoped=true&"
import script from "./TrainingVideoEdit.vue?vue&type=script&lang=js&"
export * from "./TrainingVideoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d2dc9",
  null
  
)

export default component.exports